
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M16.22 43.099c3.11.04 5.09-3.56 6.11-7.76 1.02-4.2 1.26-8.09 0-10.24-1.26-2.15-3.39-3.67-4.66-5.77-1.01-1.67-1.2-3.71-3-3.71-1.62 0-2.92 1.14-4.33 4.81-1.89 4.89-1.68 13.18 0 17.13 1.68 3.95 3.35 5.51 5.87 5.54h.01z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M13.22 20.669c.36-.48.9-1.38 1.02-1.86m11.38 34.52c2.41 1.98 6.2.41 9.62-2.23 3.42-2.64 6.04-5.52 6.41-7.99.37-2.47-.35-4.99-.03-7.41.26-1.93 1.39-3.65-.01-4.77-1.26-1.01-2.99-.93-6.38 1.04-4.53 2.64-9.55 9.23-10.72 13.37-1.17 4.13-.83 6.4 1.11 8v-.01z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M37.32 33.969c.58-.15 1.56-.51 1.96-.81m10.87-25.58c1.54 2.71-.65 6.18-3.82 9.11-3.17 2.92-6.46 5.02-8.96 4.97-2.5-.05-4.86-1.19-7.3-1.28-1.95-.07-3.83.75-4.7-.82-.78-1.41-.41-3.1 2.1-6.12 3.36-4.02 10.71-7.86 14.98-8.31 4.27-.45 6.45.26 7.69 2.45h.01zM29.08 15.829c-.24.55-.77 1.45-1.13 1.79"}})])
          )
        }
      }
    